import { waypointInit } from 'helpers/utils';

const waypointConfig = {
    selector: '.tm',
    funcs: [{ target: 'waypoint--bottom' }],
    offset: '80%',
};

class Slider {
    constructor(target) {
        this._target = target;
        this._slidesArr = [];
        this._interval = 7500;
        this._hideSlide = 'tm__slide--hidden';
        this._arrows = Array.from(target.getElementsByClassName('tm__arrow'));
        this._active = 0;
        this._current = 0;
        this._nextSlide = 1;
        this._slideshow = null;
        this._timer = null;
        this._tabTimeout = null;
        this._tabs = [];

        this._setHeaders = (headers) => {
            this._target.getElementsByClassName('js--tm-headers')[0].innerHTML = headers
                .map(
                    (k, i) =>
                        `<a href="#" class="js--tm-header tm__header ${
                            i === 0 && 'tm__header--active'
                        }" data-tab="${i}">${k}</a>`,
                )
                .join('');

            this._tabs = Array.from(this._target.querySelectorAll('.js--tm-headers a'));
            this._tabs.forEach((k) =>
                k.addEventListener('click', (e) => {
                    e.preventDefault();
                    this._handleTab(e.target);
                }),
            );
        };

        this._imageBtn = ({ slide, url }) => {
            return `<button class="tm__images__image" style="background-image: url(${url});" data-slide="${slide}"></button>`;
        };

        this._setImages = () => {
            const _images = this._target.getElementsByClassName('js--tm-images')[0];

            this._slidesArr.forEach((k, i) => {
                const images = [];

                k.forEach((j) => {
                    images.push([
                        j,
                        this._target
                            .querySelector(`.js--slides[data-group="${i}"] .js--tm-slide${j}`)
                            .getAttribute('data-image'),
                    ]);
                });

                _images.innerHTML = _images.innerHTML.concat(`
      <div class="tm__images-group ${i !== 0 && 'tm__slides--hidden'}" data-image-group="${i}">
        ${images
            .map((k) => this._imageBtn({ slide: k[0].replace(/[^\d+$]/g, ''), url: k[1] }))
            .join('')}
      </div>
    `);

                Array.from(_images.querySelectorAll('button')).forEach((k) =>
                    k.addEventListener('click', (e) =>
                        this._slideArrows(e.target.getAttribute('data-arrow')),
                    ),
                );
            });
        };

        this._setSlides = () => {
            const headers = [];

            Array.from(this._target.getElementsByClassName('js--slides')).forEach((category) => {
                const _this = category;
                const { length } = _this.getElementsByClassName('js--tm-slide');

                const arr = [];

                for (let i = 0; i < length; i++) {
                    arr.push(`[data-slide="${i}"]`);
                }
                this._slidesArr.push(arr);
                headers.push(_this.getAttribute('data-header'));
            });

            this._setHeaders(headers);
            this._setImages();

            this._active = parseInt(
                this._target.getElementsByClassName('js--tm-active')[0].getAttribute('data-group'),
                10,
            );
        };

        this._slide = () => {
            clearTimeout(this._slideshow);
            clearInterval(this._slideshow);

            this._slideshow = setInterval(() => {
                this._current = this._nextSlide;
                this._transition(
                    '.tm__slide',
                    this._slidesArr[this._active][this._nextSlide],
                    this._hideSlide,
                );
                this._nextSlide =
                    this._nextSlide + 1 >= this._slidesArr[this._active].length
                        ? 0
                        : this._nextSlide + 1;
                this._configureImages();
            }, this._interval + 1200);
        };

        this._transition = (elOne, elTwo, change) => {
            Array.from(this._target.querySelectorAll(elOne)).forEach((k) =>
                k.classList.add(change),
            );

            setTimeout(() => {
                this._target
                    .querySelector(`[data-group="${this._active}"] ${elTwo}`)
                    .classList.remove(change);

                Array.from([
                    ...this._target.getElementsByClassName('tm__arrow'),
                    ...this._target.getElementsByClassName('tm__images__image'),
                ]).forEach((k) => k.classList.remove('tm__arrow--disabled'));
            }, 200);
        };

        this._resizeSlide = () => {
            this._slideHeights = [];

            for (let i = this._slidesArr[this._active].length - 1; i >= 0; i--) {
                this._slideHeights.push(
                    getComputedStyle(
                        this._target
                            .querySelector(`.js--slides[data-group="${this._active}"]`)
                            .querySelector(this._slidesArr[this._active][i]),
                    ).height,
                );
            }

            const newHeight = this._slideHeights.sort((a, b) => a - b).pop();
            this._target.querySelector(`.js--slides[data-group="${this._active}"]`).style.height =
                newHeight;
        };

        this._slideArrows = (arrow) => {
            Array.from([
                ...this._target.getElementsByClassName('tm__arrow'),
                ...this._target.getElementsByClassName('tm__images__image'),
            ]).forEach((k) => {
                k.classList.add('tm__arrow--disabled');
            });

            if (arrow === 'right') {
                this._transition(
                    '.tm__slide',
                    `[data-slide="${this._nextSlide}"]`,
                    this._hideSlide,
                );
                this._current = this._nextSlide;
                this._nextSlide =
                    this._current + 1 >= this._slidesArr[this._active].length
                        ? 0
                        : this._current + 1;
                this._configureImages();
                return;
            }

            this._nextSlide =
                this._nextSlide - 1 <= 0
                    ? this._slidesArr[this._active].length - 1
                    : this._nextSlide - 1;

            if (this._current === 0) {
                this._nextSlide = 0;
            }

            this._current =
                this._current === 0 ? this._slidesArr[this._active].length - 1 : this._current - 1;
            this._transition('.tm__slide', `[data-slide="${this._current}"]`, this._hideSlide);
            this._configureImages();
        };

        this._throttleOrDie = () => {
            clearTimeout(this._timer);
            this._timer = setTimeout(() => this._resizeSlide(), 250);
        };

        this._handleTab = (tab) => {
            clearTimeout(this._tabTimeout);

            this._active = parseInt(tab.getAttribute('data-tab'), 10);
            const _activeCategory = this._target.querySelector(
                `.js--slides[data-group="${this._active}"]`,
            );
            const _wrapper = this._target.getElementsByClassName('tm__wrapper')[0];
            const currentHeight = getComputedStyle(
                this._target.getElementsByClassName('tm__wrapper')[0],
            ).height;

            _wrapper.style.height = currentHeight;

            this._target
                .getElementsByClassName('tm__slides--active')[0]
                .classList.add('tm__slides--hidden');
            Array.from(this._target.getElementsByClassName('tm__images-group')).forEach((k) =>
                k.classList.add('tm__slides--hidden'),
            );
            this._tabs.forEach((k) => k.classList.remove('tm__header--active'));
            tab.classList.add('tm__header--active');

            this._tabTimeout = setTimeout(() => {
                Array.from(this._target.getElementsByClassName('js--slides')).forEach((k) =>
                    k.classList.remove('tm__slides--active', 'js--tm-active'),
                );
                Array.from(this._target.getElementsByClassName('js--tm-slide')).forEach((k) =>
                    k.classList.add('tm__slide--hidden'),
                );

                this._current = 0;
                this._nextSlide = 1;

                _activeCategory.classList.add('tm__slides--active', 'js--tm-active');
                _activeCategory.classList.remove('tm__slides--hidden');
                _activeCategory
                    .querySelector('[data-slide="0"]')
                    .classList.remove('tm__slide--hidden');
                this._target
                    .querySelector(`.tm__images-group[data-image-group="${this._active}"]`)
                    .classList.remove('tm__slides--hidden');

                this._resizeSlide();
                this._slide();
                this._configureImages();

                _wrapper.style.height = 'auto';
            }, 1);
        };

        this._updateImg = (el, order, activeImg) => {
            el.setAttribute('data-arrow', '');

            if (order !== 2) {
                el.setAttribute('data-arrow', order === 1 ? 'left' : 'right');
            }

            el.classList.remove('tm--order1', 'tm--order2', 'tm--order3');
            el.classList.add(`tm--order${order}`, activeImg ? 'tm__images--active' : false);
            el.classList.remove('tm__images--hidden');
        };

        this._getImageEl = (group, slideNum) => {
            return this._target.querySelector(
                `.tm__images-group[data-image-group="${group}"] button[data-slide="${slideNum}"]`,
            );
        };

        this._configureImages = () => {
            const previous =
                this._current - 1 < 0
                    ? this._getImageEl(this._active, this._slidesArr[this._active].length - 1)
                    : this._getImageEl(this._active, this._current - 1);
            const currentImg = this._getImageEl(this._active, this._current);
            const next =
                this._current + 1 >= this._slidesArr[this._active].length
                    ? this._getImageEl(this._active, 0)
                    : this._getImageEl(this._active, this._current + 1);

            Array.from(this._target.getElementsByClassName('tm__images__image')).forEach((k) => {
                k.classList.add('tm__images--hidden');
                return k.classList.remove('tm__images--active');
            });

            this._updateImg(previous, 1);
            this._updateImg(currentImg, 2, true);
            this._updateImg(next, 3);
        };
    }

    init() {
        this._setSlides();
        this._configureImages();
        this._slide();
        setTimeout(this._resizeSlide, 0);

        this._target.addEventListener('mouseover', () => clearInterval(this._slideshow));
        this._target.addEventListener('mouseout', () => this._slide());
        this._arrows.forEach((k) =>
            k.addEventListener('click', (e) => {
                e.preventDefault();
                this._slideArrows(
                    e.target.getAttribute('data-arrow') ||
                        e.target.closest('.tm__arrow').getAttribute('data-arrow'),
                );
            }),
        );

        window.addEventListener('resize', () => this._throttleOrDie());
    }
} // end

function init() {
    waypointInit(waypointConfig);
    const arr = [];

    Array.from(document.getElementsByClassName('tm')).forEach((k) => {
        arr.push(() => new Slider(k).init());
    });

    arr.forEach((k) => k());
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/testimonials.js